module.exports = __webpack_public_path__ + "img/filter.4860251b.svg";